import { createFileRoute, Outlet } from "@tanstack/react-router"
import { AnimatePresence, motion } from "motion/react"

import { generateMetaTags } from "@repo/seo/generate-meta-tags"
import { sharedConfig } from "~/lib/config/shared"

export const Route = createFileRoute("/_auth-layout")({
  component: AuthLayout,
  head: ({ match }) => ({
    meta: generateMetaTags({
      base: {
        title: `Auth | ${sharedConfig.appName}`,
        description: `${sharedConfig.appName} Auth`,
        url: sharedConfig.baseUrl + match.fullPath,
      },
      robots: ["noindex", "nofollow", "noarchive"],
    }),
  }),
})

function AuthLayout() {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        className="relative z-10 flex w-full flex-col items-center justify-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        <motion.div
          className="relative w-full"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{
            type: "spring",
            stiffness: 100,
            damping: 15,
          }}
        >
          <Outlet />
        </motion.div>
      </motion.div>
    </AnimatePresence>
  )
}
